<template>
  <div>
    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isActive"
    >
      <div
        class="mt-6 flex items-center justify-between px-6"
        v-if="existingStocktake"
      >
        <div class="flex items-center">
          <img width="40" :src="ProductIcon" class="mr-4" />
          <div>
            <h4>Stocktake</h4>
            <small>
              <code>{{ existingStocktake.stocktakeType }}</code> at
              {{ existingStocktake | date }}</small
            >
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isActive = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <Loading v-if="isLoading" />

        <div v-else class="p-6">
          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Submitted by</span>
            </div>
            <div>
              <p
                v-if="existingStocktake.committedBy"
                class="text-sm text-gray-600"
              >
                {{ existingStocktake.committedBy.username }} ({{
                  existingStocktake.committed | date
                }})
              </p>
              <p v-else class="text-sm text-gray-600">Not yet submitted</p>
            </div>
          </div>

          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Deadline</span>
            </div>
            <div>
              <p class="text-sm text-gray-600">
                <span
                  class="text-gray-900 font-medium"
                  v-if="existingStocktake.stocktakeDeadlineDate"
                  >{{ existingStocktake.stocktakeDeadlineDate | date }}</span
                >
                <span class="text-gray-600 font-normal" v-else>
                  No deadline</span
                >
              </p>
            </div>
          </div>

          <!--  <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Type</span>
            </div>
            <div>
              <p class="text-sm text-gray-600">
                <vs-chip color="primary">{{ existingStocktake.stocktakeType }}</vs-chip>
                
              </p>
            </div>
          </div> -->

          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Status</span>
            </div>
            <div>
              <p class="text-sm text-gray-600">
                <vs-chip color="success">{{
                  existingStocktake.status
                }}</vs-chip>
              </p>
            </div>
          </div>

          <div class="flex flex-col mb-3" v-if="isRM">
            <div class="mb-1 text-sm">
              <span>Deviating products</span>
            </div>
            <div>
              <p
                v-if="
                  !existingStocktake.stocktakeDeviations
                    .stocktakeProductDeviations ||
                  existingStocktake.stocktakeDeviations
                    .stocktakeProductDeviations.length < 1
                "
              >
                No deviations
              </p>
              <vs-table
                v-else
                :data="
                  existingStocktake.stocktakeDeviations
                    .stocktakeProductDeviations
                "
                style="margin-left: -24px; margin-right: -24px"
                noDataText=""
              >
                <!--     <template slot="header">
                  <h3 class="ml-6 mb-1">Products</h3>
                </template> -->
                <template slot="thead">
                  <!--                   <vs-th sort-key="namne"> Number </vs-th> -->
                  <vs-th sort-key="amount"> Name </vs-th>
                  <vs-th>Deviation</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                    <vs-td>
                      <span class="text-muted"> {{ tr.displayName }}</span>
                    </vs-td>

                    <vs-td>
                      <code
                        ><span class="text-muted">
                          {{ tr.deviation }}</span
                        ></code
                      >
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <p v-for="id in stocktake.stockProductIds" :key="id">{{ id }}</p> -->
            </div>
          </div>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button type="border" @click="isActive = false">Close</vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/recount-icon.png";
import { mapGetters } from "vuex";
import { DatePicker } from "v-calendar";
import PopupAddProduct from "./PopupAddProduct.vue";

export default {
  components: {
    DatePicker,
    VuePerfectScrollbar,
    PopupAddProduct,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,

      isActive: false,
      isLoading: true,
      existingStocktake: null,

      stocktake: null,
    };
  },
  computed: {
    ...mapGetters({
      activeVenueId: "venues/activeVenueId",
      totalVenueStock: "stockProducts/totalVenueStock",
      isRM: "users/isRM",
    }),
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    /* filteredProducts() {
      console.log("filteredProducts", this.stocktake.stockProductIds);
      if (!this.stocktake) return [];
      return this.totalVenueStock.filter((x) =>
        this.stocktake.stockProductIds.includes(x.stockProductId.id)
      );
    }, */
  },
  methods: {
    async showSubmitted(existingStocktake) {
      this.existingStocktake = existingStocktake;

      this.isActive = true;
      await this.loadExternalData();
      this.isLoading = false;
    },

    async loadExternalData() {
      await this.$store.dispatch(
        "stockProducts/getTotalVenueStock",
        this.activeVenueId
      );
      console.log("Total venue stock", this.totalVenueStock);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>